import {createSelector} from 'reselect';
import GroupAdminState from "./GroupAdminState";

const stateContractGroups = (state: GroupAdminState) => state.contractGroups;
const stateSelectedContractGroupId = (state: GroupAdminState) => state.selectedContractGroupId;
const stateUser = (state: GroupAdminState) => state.user;
const stateHighlightedUsername = (state: GroupAdminState) => state.highlightedUserName;
const stateIsLoading = (state: GroupAdminState) => state.isLoading;


export const contractGroups = createSelector(
    [stateContractGroups],
    (contractGroups) => {
        return contractGroups;
    }
);

export const selectedContractGroupId = createSelector(
    [stateSelectedContractGroupId, contractGroups],
    (selectedContractGroupId, contractGroups) => {
        if (selectedContractGroupId) return selectedContractGroupId;
        if (contractGroups.length > 0) return contractGroups[0].id;
    }
);


export const selectedContractGroup = createSelector(
    [selectedContractGroupId, contractGroups],
    (selectedContractGroupId, contractGroups) => {
        return contractGroups.find(group => {
            return group.id === selectedContractGroupId
        })
    }
);

export const highlightedUsername = createSelector(
    [stateHighlightedUsername], (username) => {
        return username
    }
);

export const selectedContractGroupUsers = createSelector(
    [selectedContractGroup, highlightedUsername], (contractGroup, highlightedUsername) => {
        if (contractGroup) {
            if (highlightedUsername) {
                return contractGroup.users.sort((a, b) => {
                    return (a.username == highlightedUsername) ? -1 : 0;
                })
            }
            return contractGroup.users;
        }
        return [];
    }
);

export const userCanViewGroups = createSelector(
    [stateUser], (user) => {
        return user && user.hasPermissionInAnyScope("UI_CONTRACTGROUP_ADMIN", "VIEW");
    }
);

export const userCanCreateGroups = createSelector(
    [stateUser], (user) => {
        return user && user.hasPermissionInAnyScope("CONTRACTGROUP", "CREATE")
    }
);


export const isLoading = createSelector(
    [stateIsLoading],(isLoading) =>{
        return isLoading;
    }
)






